import request from '@/utils/request'


export function listInfoPub(query) {
  return request({
    url: '/web/xwqy/infoPub/list',
    method: 'get',
    params: query
  })
}


export function getInfoPub(recid) {
  return request({
    url: '/web/xwqy/infoPub/' + recid,
    method: 'get'
  })
}
